import * as React from "react";
import { BusinessListingItem } from "@/lib/data/applicators";

export interface DayHours {
  day: number; // 0=Sun .. 6=Sat
  intervals: { open: string; close: string }[];
}
export interface ParsedHours {
  today: DayHours | null;
  weekly: DayHours[];
  tz: string | null | undefined;
  weekdayText: string[];
}

const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function normalizeDayStructure(
  hours?: BusinessListingItem["hours"]
): DayHours[] {
  const periods = hours?.periods || [];
  const map: Record<number, { open: string; close: string }[]> = {
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
  };
  for (const p of periods) {
    for (const iv of p.intervals) {
      map[p.day].push({ open: iv.open, close: iv.close });
    }
  }
  return Object.entries(map).map(([day, intervals]) => ({
    day: Number(day),
    intervals,
  }));
}

export function useBusinessHours(business: BusinessListingItem): ParsedHours {
  return React.useMemo(() => {
    const weekly = normalizeDayStructure(business.hours);
    const todayIdx = new Date().getDay();
    const today = weekly.find((d) => d.day === todayIdx) || null;
    return {
      today,
      weekly,
      tz: business.hours?.tz,
      weekdayText: business.hours?.weekday_text || [],
    };
  }, [business.hours]);
}

export function formatIntervals(
  intervals: { open: string; close: string }[]
): string {
  if (!intervals.length) return "Closed";
  return intervals.map((i) => `${i.open}–${i.close}`).join(", ");
}

export function dayName(day: number): string {
  return DAY_NAMES[day] ?? String(day);
}
